import {t} from '../../../common/getTranslations';
import {twMerge} from '../../../common/twMerge';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Text} from '../../atoms/Text/Text';
import {ViewerSettingReadTypeProps} from './ViewerSettingReadTypeProps.interface';
import {ViewerSettingScrollableItem} from './ViewerSettingScrollableItem';

export function ViewerSettingReadType({
  isMobile,
  // XXX : readType1, readType2가 아닌 좀 더 명시적인 방법이 생각이 안나 이렇게 진행해 둡니다..!
  readType1,
  readType2,
  isReadType1Disabled,
  isReadType2Disabled,
  currentReadType,
  onClickReadType,
  ...props
}: ViewerSettingReadTypeProps) {
  return (
    <ViewerSettingScrollableItem
      isMobile={isMobile}
      title={t('viewer_setting_mode')}
      {...props}
    >
      <Text
        className={twMerge([
          'mr-14pxr cursor-pointer',
          currentReadType === 'Type1'
            ? 'font-small1-bold text-theme-solid-100'
            : 'font-small1 text-theme-solid-40',
          isReadType1Disabled && 'opacity-30',
        ])}
        {...putTiaraObjectProps({
          click: {
            layer1: '뷰어설정',
            copy: readType1,
          },
        })}
        onClick={
          isReadType1Disabled
            ? undefined
            : e =>
                LOG_CLICK_EVENT('열람방식_클릭', e, () => {
                  onClickReadType('Type1');
                  e.stopPropagation();
                })
        }
      >
        {readType1}
      </Text>
      <Text
        className={twMerge(
          'cursor-pointer',
          currentReadType === 'Type2'
            ? 'font-small1-bold text-theme-solid-100'
            : 'font-small1 text-theme-solid-40',
          isReadType2Disabled && 'opacity-30'
        )}
        {...putTiaraObjectProps({
          click: {
            copy: readType2,
          },
        })}
        onClick={
          isReadType2Disabled
            ? undefined
            : e =>
                LOG_CLICK_EVENT('열람방식_클릭', e, () => {
                  onClickReadType('Type2');
                })
        }
      >
        {readType2}
      </Text>
    </ViewerSettingScrollableItem>
  );
}
